import { useRouter } from 'next/router';
import { useBasePath } from '../../../../lib/use-base-path';
import { markNavFromDrawer } from '../../../../lib/drawer-nav';
import { useLeaveChatOnNavigate } from '../../../../lib/use-leave-chat';
import { useUnreadNotifications } from '../../../../lib/use-unread-notifications';
import { useTranslation } from '../../../../lib/i18n';
import { useGenericBi } from '../../../../lib/use-generic-bi';
import { IconButton } from '../../ui';
import { BellIcon } from '../components/icons';
import styles from './RailBell.module.css';

// The wide rail's bell (Figma `Sidebar-Menu` 22012:378929): a 36px ghost icon button beside the
// collapse toggle in the open rail's header, and the first glyph of the collapsed strip. The unread
// state is a plain peach dot on the glyph's top-trailing corner, no number, hidden at 0. The count is
// the server's UNSEEN count (see useUnreadNotifications), cleared by a visit to /notifications.
export function RailBell() {
  const { t } = useTranslation();
  const basePath = useBasePath();
  const router = useRouter();
  const leaveChat = useLeaveChatOnNavigate();
  const { logPageClickBi } = useGenericBi();
  const unreadCount = useUnreadNotifications();
  const label = t('nav.notifications');
  return (
    <span className={styles.wrap}>
      <IconButton
        href="/notifications"
        linkAs={`${basePath}/notifications`}
        aria-label={label}
        aria-current={router.pathname === '/notifications' ? 'page' : undefined}
        size="medium"
        onClick={() => {
          logPageClickBi({ page_name: 'menu', button_name: 'drawer_notifications', origin: 'menu' });
          markNavFromDrawer();
          leaveChat();
        }}
      >
        <BellIcon />
      </IconButton>
      {unreadCount > 0 && <span aria-hidden className={styles.dot} />}
    </span>
  );
}
